import {frontend} from 'pageflow-scrolled/frontend';
import {DefaultNavigationPresenceProvider} from 'pageflow-scrolled/widgets/defaultNavigation';

import {BvzNavigation, NoenNavigation} from './Navigation';

frontend.widgetTypes.register('bvzNavigation', {
  component: BvzNavigation,
  presenceProvider: DefaultNavigationPresenceProvider
});

frontend.widgetTypes.register('noenNavigation', {
  component: NoenNavigation,
  presenceProvider: DefaultNavigationPresenceProvider
});
